import axios from 'axios';

const userData = JSON.parse(localStorage.getItem('access_token'));


//? Local URL
// export const BASE_URL = 'http://localhost:5000';

//  Prod URL
export const BASE_URL = 'https://uwp.srmist.edu.in/be/';
const API = axios.create({
  baseURL: BASE_URL,
});
const API2 = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'multipart/form-data', authorization: `Bearer ${userData ? userData.token : {}}` },
});

export const signUp = data => API.post('/user/signup', data);
export const login = data => API.post('/user/login', data);
export const forgotPassword = data => API.post('/user/forgotPassword', data);
export const resetPassword = (data, access_token) =>
  API.post('/user/resetPassword', data, { headers: { Authorization: `Bearer ${access_token}` } });
export const acceptUser = (data, access_token) =>
  API.post('/admin/verifyUser', data, { headers: { Authorization: `Bearer ${access_token}` } });
export const rejectUser = (data, access_token) =>
  API.post('/admin/rejectUser', data, { headers: { Authorization: `Bearer ${access_token}` } });
export const signUpData = access_token =>
  API.get('admin/getReq', { headers: { Authorization: `Bearer ${access_token}` } });

export const fetchNews = () => API.get('/home/getNews');
export const fetchSliderImage = () => API.get('/getSliderImage');
export const postNews = (data, access_token) =>
  API.post('/admin/uploadNews', data, { headers: { Authorization: `Bearer ${access_token}` } });
export const deleteNews = (data, access_token) =>
  API.post('/admin/deleteNews', data, { headers: { Authorization: `Bearer ${access_token}` } });

export const getAnnouncement = `${BASE_URL}/admin/getAnnouncement`;
export const getNewsletter = `${BASE_URL}/admin/getNewsletter`;
export const getUpdates = `${BASE_URL}/admin/getUpdate`;
export const getNews = `${BASE_URL}/home/getNews`;
export const contactUs = data => API.post('/home/query', data);

export const uploadProjectUser = (data, access_token) =>
  API.post('/user/uploadProject', data, { headers: { Authorization: `Bearer ${access_token}` } });
export const uploadProjectAdmin = (data, access_token) =>
  API.post('/admin/uploadProject', data, { headers: { Authorization: `Bearer ${access_token}` } });
export const fileUpload = data => API2.post('user/paperPdfUpload', data);

export const getAllProjectInfo = access_token =>
  API.get('/admin/getPaperReq', {
    headers: { Authorization: `Bearer ${access_token}` },
  });
export const publishedPapers = access_token =>
  API.get('/admin/publishedPaper', {
    headers: { Authorization: `Bearer ${access_token}` },
  });
export const getAllProjectInfoAdmin2 = access_token =>
  API.get('/admin/getAllPaperReq', { headers: { Authorization: `Bearer ${access_token}` } });

export const getIndicators = access_token =>
  API.get('/admin/getIndicator', { headers: { Authorization: `Bearer ${access_token}` } });
export const postIndicators = access_token =>
  API.post('/admin/uploadIndicator', { headers: { Authorization: `Bearer ${access_token}` } });

export const acceptProject = (data, access_token) =>
  API.post('/admin/acceptPaperReq', data, { headers: { Authorization: `Bearer ${access_token}` } });
export const rejectProject = (data, access_token) =>
  API.post('/admin/rejectPaperReq', data, { headers: { Authorization: `Bearer ${access_token}` } });
export const postAnnouncement = (data, access_token) =>
  API.post('/admin/uploadAnnouncement', data, { headers: { Authorization: `Bearer ${access_token}` } });
export const fetchAnnouncement = (data, access_token) =>
  API.get('/admin/getAnnouncement', data, { headers: { Authorization: `Bearer ${access_token}` } });
export const deleteAnnouncement = (data, access_token) =>
  API.post('/admin/deleteAnnouncement', data, { headers: { Authorization: `Bearer ${access_token}` } });

export const postUdaptes = (data, access_token) =>
  API.post('/admin/uploadUpdate', data, { headers: { Authorization: `Bearer ${access_token}` } });
export const deleteUpdateAPI = (data, access_token) =>
  API.post('/admin/deleteUpdate', data, { headers: { Authorization: `Bearer ${access_token}` } });
export const postNewsletter = (data, access_token) =>
  API.post('/admin/newsletterUpload', data, { headers: { Authorization: `Bearer ${access_token}` } });
export const newsletterFileUpload = data => API2.post('admin/newsletterFileUpload', data);
export const deleteNewsletter = (data, access_token) =>
  API.post('/admin/deleteNewsletter', data, { headers: { Authorization: `Bearer ${access_token}` } });
export const postAdmin = (data, access_token) =>
  API.post('/admin/createAdmin', data, { headers: { Authorization: `Bearer ${access_token}` } });